import React from 'react';
import {I18n} from 'react-redux-i18n';

class NoAccessPage extends React.Component
{
	render() {
    return (
      <div className="container-fluid main" id="main">
        <div className="row">
          <div className="col-lg-12">
            <h1 className="float-left">{I18n.t('ACCESS_WELCOME')}</h1> 
          </div> 
        </div>
      </div>
    );
  }
}

export default NoAccessPage;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/NoAccessPage.js
 **/